import * as _ from 'lodash';

import template from './shopVoziqOfferModal.html';

class ShopVoziqOfferModalController {

    /* @ngInject */
    constructor($scope, dataContext, $rootScope, $uibModal, $window, constants, cartService, $q, fpStore ) {
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;

        this.$scope = $scope;
        this.dataContext = dataContext;
        this.$uibModal = $uibModal;
        this.$window = $window;
        this.constants = constants;
        this.dataContext = dataContext;
        this.$rootScope = $rootScope;
        this.cartService = cartService;
        this.$scope = $scope;
        this.$q = $q;
        this.fpStore = fpStore;
    }

    close() {
        this.$close();
    }

    goToCart(offer) {
        this.addProductsToCart(offer).finally(() => {
            if (offer && offer.offerType !== 'Coupon for Equipment') {
                this.$window.location.href = this.constants.cartHref;
            } else {
                this.$close();
            }
        });

    }

    addProductsToCart(offer) {
        const settings = [{
            Name: offer.ShopCouponCode,
            Value: 'True'
        }];

        this.productIds = offer.Products && offer.Products.map((p) => p.ShopProductId);

        return this.dataContext.settings.updateUserSettings(settings).then(() => {
            this.$rootScope.$emit(this.constants.updatingCart, ['true']);

            if (this.productIds && this.productIds.length > 0) {
                return this.cartService.clearCart().then(() => {
                    return this.cartService.addLineItems(this.productIds, 1, '0').then(() => {
                        this.$rootScope.$emit(this.constants.updatingCart, ['false']);
                    });
                });
            }

            this.$rootScope.$emit(this.constants.updatingCart, ['false']);
            return this.$q.resolve();
        }).then(() => {
            return this.cartService.addCoupon(offer.ShopCouponCode, 0, 0)
                .then(() => {
                    this.$rootScope.$broadcast('cartItemsChanged');
                });
        });
    }

    continueShopping(offer) {
        this.addProductsToCart(offer).finally(() => this.$close());
    }

    continue(voziqOfferID) {
        this.selectedVoziqOfferID = voziqOfferID;
        this.modalButtonOneText = 'Go to Cart';
        this.modalButtonTwoText = 'Continue Shopping';
        let offer = _.find(this.config.offers, o => o.VoziqOfferID === this.selectedVoziqOfferID);

        this.$close();
        let modalInstance = this.$uibModal.open({
            template: '<fp-docusign-contract-modal config="config"></fp-docusign-contract-modal>',
            size: 'lg',
            backdrop: 'static',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss,
                    title: 'SPECIAL OFFER',
                    offerId: voziqOfferID,
                    confirmButtonOne: {
                        text: this.modalButtonOneText,
                        shouldShow: offer.OfferType !== 'Coupon for Equipment'
                    },
                    confirmButtonTwo: {
                        text: this.modalButtonTwoText,
                        shouldShow: true
                    }
                };
            }
        });

        modalInstance.result.then((closingCommand) => {
            if (closingCommand === this.modalButtonOneText) {
                this.goToCart(offer);
            }
            else if (closingCommand === this.modalButtonTwoText) {
                this.continueShopping(offer);
            }
        });
    }
}

export default {
    template: template,
    bindings: {
        config: '='
    },
    controller: ShopVoziqOfferModalController
};
